import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import Card from 'components/card/Card'
import Button from 'components/button/Button'
import { validationSchemaFormStockPrice } from 'helpers/validation'
import { usePricelists } from '../../hooks/usePricelists'
import BasicInformation from '../../components/pricelists/form/BasicInformation'
import Price from '../../components/pricelists/form/Price'
import Configuration from '../../components/pricelists/form/Configuration'

export default function PricelistForm() {
  const navigate = useNavigate()
  const {
    isLoadingForm,
    formStockPrice,
    onSubmitForm,
    onChangeProductNameSearch,
    products,
    onDropDownScrollFetch,
    fetchProducts,
    toastContainer,
  } = usePricelists()

  const formik = useFormik({
    initialValues: formStockPrice,
    enableReinitialize: true,
    validationSchema: validationSchemaFormStockPrice,
    validateOnBlur: true,
    onSubmit: async values => {
      await onSubmitForm(values)
    },
  })

  useEffect(() => {
    fetchProducts()
  }, [])

  return (
    <div className="content-wrapper">
      {toastContainer}
      <Card className="bg-transparent p-0" loading={isLoadingForm}>
        <div className="flex flex-col gap-4">
          <BasicInformation
            state={formik}
            helpers={formik}
            onDropDownScrollFetch={onDropDownScrollFetch}
            onChangeProductNameSearch={onChangeProductNameSearch}
            products={products}
          />
          <Price state={formik} helpers={formik} />
          <Configuration state={formik} helpers={formik} />
        </div>
      </Card>
      <div className="mt-4 xl:flex xl:flex-row xl:justify-end xl:gap-4">
        <Button
          data-testid="btn_accept"
          className="pt-3 rounded-xl pb-3 font-bold text-sm"
          label="Batalkan"
          variant="outline-primary"
          loading={isLoadingForm}
          onClick={() => navigate(`/inventory/stock-location/stock/${formStockPrice.storeId}`)}
        />
        <Button
          data-testid="btn_accept"
          className="pt-3 rounded-xl pb-3 font-bold text-sm"
          label="Simpan"
          variant="solid-primary"
          loading={isLoadingForm}
          onClick={formik.handleSubmit}
          type="submit"
        />
      </div>
    </div>
  )
}
